import { Minus, Plus } from "lucide-react";

export function Stepper({ label, value, min, max, onChange, suffix, testId }) {
  return (
    <div className="lux-card flex items-center justify-between px-4 py-3" data-testid={testId}>
      <div>
        <p className="eyebrow text-[10px]">{label}</p>
        <p className="mt-1 font-display text-2xl text-ivory" data-testid={`${testId}-value`}>
          {value}
          {suffix && <span className="ml-1.5 font-body text-xs text-mist">{suffix}</span>}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {[
          { icon: Minus, next: value - 1, disabled: value <= min, id: "decrement" },
          { icon: Plus, next: value + 1, disabled: value >= max, id: "increment" },
        ].map(({ icon: Icon, next, disabled, id }) => (
          <button
            key={id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(next)}
            data-testid={`${testId}-${id}`}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-line bg-elevated text-ivory transition-[border-color,transform,opacity] duration-200 hover:border-gold/50 active:scale-95 disabled:opacity-30"
          >
            <Icon className="h-4 w-4" />
          </button>
        ))}
      </div>
    </div>
  );
}
